nav {
	/* Color */
	background-color: var(--menu-background-color);

	/* Position */
	position: sticky;

	/* Dimensions */
	height: 100%;
}
.submenu {
	padding-left: 20px;
  }

  .submenu-item {
	display: block;
	padding: 5px 0;
  }
button {
	/* Position */
	position: absolute;
	right: 0px;
	top: 50%;
	transform: translate(0%, -50%);

	/* Dimensions */
	height: 38px;
	width: 20px;

	/* Spacing */
	padding: 0px;

	/* Flex */
	display: flex;
	align-items: center;
	justify-content: center;

	/* Color */
	background-color: var(--primary-color);
	
	/* Border */
	border-radius: 5px 0px 0px 5px;
	border-width: 0px;

	/* Cursor */
	cursor: pointer;
}

button:hover {
	background-color: var(--primary-highlight);
}